<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import { config } from '@/config'
import sl from '@/Prevodi/Ultralight_beri-sl.json';
import en from '@/Prevodi/Ultralight_beri-en.json';
import it from '@/Prevodi/Ultralight_beri-it.json';
export default {
  components: {
    DropDown,
    Notification
  },
  props: {
    PodatkiObracun: Object,
    PodatkiNezakljuceni: Object,
    user: Object,
  },
  emits: ['datumo', 'datumk', 'osvezi'],
  data() {
    return {
      prevodi: false,
      datumO: new Date().toISOString().split('T')[0],
      datumD: new Date().toISOString().split('T')[0],
      pilotName: '',
      filterPilot: '',
      filterLetalo: '',
      filterInstruktor: '',
      instructorName: '',
      regLetala: '',
      krajVzleta: 'LJAJ',
      krajPristanka: 'LJAJ',
      poletanje: '',
      casVziga: '', //nepomembno
      pristanek: '',
      casUgasanja: '', //nepomembno
      opomba: '',
      IzbranNamen: '',
      IzbranaNaloga: '',
      CasLetenja: '',
      KlubLetala: '',
      KlubPilot: '',
      DatumLetenja: '',
      DatumVnosa: '',
      CasPristanka: '',
      dPilot: false,
      dLetalo: false,
      dInstruktor: false,
      dFiltri: false,
      dNamen: false,
      dNaloga: false,
      dPristanek: false,
      dVzlet: false,
      Letala: [],
      Piloti: [],
      Instruktor: [],
      Letalisca: [],
      stPristankov: 1,
      Klubi: [],
      namen: [
        {id: 0, namen: 'Trenažni let'},
        {id: 1, namen: 'Kontrolni let'},
        {id: 2, namen: 'Osnovno šolanje'},
        {id: 3, namen: 'Šolanje za poob.'},
        {id: 4, namen: 'Tekmovalni let'},
        {id: 5, namen: 'Izpitni let'},
        {id: 6, namen: 'Preizkusni let'},
        {id: 7, namen: 'Uvodni let'},
        {id: 8, namen: 'Protipožarni let'},
        {id: 9, namen: 'AK'},
      ],
      naloga: [
        // {id:0, naloga: 'Šolski krog'}, //pri urejanju ne more izbrat šolskega kroga
        {id: 1, naloga: 'Vleka'},
        {id: 2, naloga: 'Let v rajonu'},
        {id: 3, naloga: 'Prelet'},
        {id: 4, naloga: 'Ruta'},
      ],
      // PodatkiObracuna: [],
      izbranZapis: [],
      podatkiIzbris: {},
      prikaz: 'motorna',
      izracun: [],
      urejanje: false,
      idUrejanja: '',
      sortAscending: true,
      text: '',
      types: '',
      ShowNoti: false,
      pravice: [],
      praviceUrejanja: false,
      praviceUrejanjaVseh: false,
      praviceBrisanja: false,
      praviceBrisanjaVseh: false,
      stanjeStevca: '',
      v_zraku: '',
      pot: config.baseUrl,
      sending: false,
      exporting: false,
      printing: false,
      dniPregleda: null,
      dodajam: false
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    // this.GetPodatkiObracuna();
    this.GetLetala();
    this.GetPiloti();
    this.GetLetalisca();
    this.GetPravice();
    if(config.UserLVL === 2) {
      this.NastavitevPregleda();
    }
  },
  computed: {
    FiltriraniPodatki() {
      if (this.filterPilot !== '') {
        if (this.filterLetalo !== '') {
          if (this.filterInstruktor !== '') {
            return this.PodatkiObracun.filter(zapis => zapis.registracija === this.filterLetalo && zapis.pilot === this.filterPilot && zapis.instruktor === this.filterInstruktor);
          } else {
            return this.PodatkiObracun.filter(zapis => zapis.registracija === this.filterLetalo && zapis.pilot === this.filterPilot);
          }
        }
        if (this.filterInstruktor !== '') {
          return this.PodatkiObracun.filter(zapis => zapis.pilot === this.filterPilot && zapis.instruktor === this.filterInstruktor);
        } else {
          return this.PodatkiObracun.filter(zapis => zapis.pilot === this.filterPilot);
        }

      }
      if (this.filterLetalo !== '') {
        if (this.filterInstruktor !== '') {
          return this.PodatkiObracun.filter(zapis => zapis.registracija === this.filterLetalo && zapis.instruktor === this.filterInstruktor);
        } else {
          return this.PodatkiObracun.filter(zapis => zapis.registracija === this.filterLetalo);
        }
      }
      if (this.filterInstruktor !== '') {
        return this.PodatkiObracun.filter(zapis => zapis.instruktor === this.filterInstruktor);
      }
      return this.PodatkiObracun;
    },
  },
  methods: {
    GetLetalisca() {
      let app = this;
      axios
          .get("./api/sifranti/letalisca/beri/")
          .then(function (response) {
            app.Letalisca = response.data;
          })
          .catch(function (napaka) {
            // alert("Napaka pri vnosu: " + napaka.response.data.message);
          })
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].vrsta_letala === 'Motorno') {
                app.Letala.push(response.data.letala[i]);
              }
            }
            // app.Letala = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPiloti() {
      let app = this;
      axios
          .get("./api/sifranti/piloti/izpis/")
          .then(function (response) {
            if (app.user.lvl < 4) {
              app.Piloti = response.data;
            } else {
              app.Piloti.piloti = response.data.piloti.filter(pilot => pilot.email === app.user.email);
            }
            app.Instruktor = response.data.piloti.filter(pilot => pilot.instruktor === true || pilot.instruktor_ultralight === true && pilot.datum_izbrisa == null);
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPodatkiObracuna() {
      this.$emit('datumo', this.datumO);
      this.$emit('datumk', this.datumD);
      this.$emit('osvezi');
    },
    GetPravice() {
      if (this.user.lvl > 1) {
        var podatki = new URLSearchParams();
        podatki.append('uID', this.user.id);
        podatki.append('menuID', '3'); //hardcoded številka menija
        axios.post('./api/uporabniki/pravice/izpis/', podatki, {withCredentials: true}).then((response) => {
          this.pravice = response.data.pravice;
          this.PreveriPravice(this.pravice);
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = this.$t('obvestila.napakaBranja');
          } else {
            this.text = this.$t('obvestila.napakaBranja');
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      } else { //če je user lvl 0 ali 1 ima avtomatsko pravice urejanja in brisanja
        this.praviceUrejanja = true;
        this.praviceUrejanjaVseh = true;
        this.praviceBrisanja = true;
        this.praviceBrisanjaVseh = true;
      }
    },
    PreveriPravice(pravice) { //nastavljanje pravic uporabnika za branje in brisanje
      for (var i = 0; i < pravice.length; i++) {
        switch (pravice[i].za) { //switch case glede na poslane pravice
          case 'urejanje':
            this.praviceUrejanja = pravice[i].omogoceno;
            break;
          case 'urejanje_vse':
            this.praviceUrejanjaVseh = pravice[i].omogoceno;
            break;
          case 'brisanje':
            this.praviceBrisanja = pravice[i].omogoceno;
            break;
          case 'brisanje_vse':
            this.praviceBrisanjaVseh = pravice[i].omogoceno;
            break;
          default:
            // default ni nastavljen
        }
      }
    },
    LahkoUreja() { //preverjanje pravic urejanja, če lahko uporabnik določen zapis ureja
      var danes = new Date().toISOString().split('T')[0].split('-').reverse();
      danes = danes[0] + '.' + danes[1] + '.' + danes[2];
      if (this.praviceUrejanjaVseh || this.user.lvl <= 3) { //preverjanje pravic urejanja vseh zapisov
        return true;
      } else return this.izbranZapis[0].vnesel === Number(this.user.id) && this.izbranZapis[0].datum === danes;
    },
    LahkoBrise() {
      if (this.praviceBrisanjaVseh) {//preverjanje pravic brisanja vseh zapisov
        return true;
      } else if (this.praviceBrisanja) {//preverjanje pravic brisanja lastnih zapisov
        return this.izbranZapis[0].vnesel === Number(this.user.id);
      } else {
        return false;
      }
    },
    OpenView(id) {
      this.izbranZapis = this.PodatkiObracun.filter(p => p.id === id);
      $(this.$refs.modalObracunMotZapisa).modal('show');
    },
    OpenViewZ(id) {
      this.izbranZapis = this.PodatkiNezakljuceni.filter(p => p.id === id);
      this.$nextTick(() => {
        this.UrediZapis(id);
        $(this.$refs.modalObracunOdprti).modal('show');
        setTimeout(() => this.$refs.pristanekZ?.focus(), 0);
      });
    },
    Details(id) {
      this.izbranoLetalo = this.letala.filter(letalo => letalo.id === id);
      $(this.$refs.modalObracunMotZapisa).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalObracunMotZapisa).modal('hide');
      this.urejanje = false;
      this.pilotName = '';
      this.instructorName = '';
      this.regLetala = '';
      this.krajVzleta = '';
      this.krajPristanka = '';
      this.poletanje = '';
      this.pristanek = '';
      this.opomba = '';
      this.IzbranNamen = '';
      this.IzbranaNaloga = '';
      this.stPristankov = '';
    },
    DetailsOffZ() {
      $(this.$refs.modalObracunOdprti).modal('hide');
      $(this.$refs.modalObracunMotZapisa).modal('hide');
      this.urejanje = false;
      this.pristanek = '';
    },
    UrediZapis(id) {
      this.idUrejanja = id;
      this.urejanje = true;
      this.pilotName = (this.izbranZapis[0].pilot == null) ? '' : this.izbranZapis[0].pilot;
      this.instructorName = (this.izbranZapis[0].instruktor == null) ? '' : this.izbranZapis[0].instruktor;
      this.regLetala = (this.izbranZapis[0].registracija == null) ? '' : this.izbranZapis[0].registracija;
      this.krajVzleta = (this.izbranZapis[0].kraj_vzleta == null) ? '' : this.izbranZapis[0].kraj_vzleta;
      this.krajPristanka = (this.izbranZapis[0].kraj_pristanka == null) ? '' : this.izbranZapis[0].kraj_pristanka;
      this.poletanje = (this.izbranZapis[0].cas_vzleta == null) ? '' : this.izbranZapis[0].cas_vzleta;
      this.pristanek = (this.izbranZapis[0].cas_pristanka == null) ? '' : this.izbranZapis[0].cas_pristanka;
      this.opomba = (this.izbranZapis[0].opomba == null) ? '' : this.izbranZapis[0].opomba;
      this.IzbranNamen = (this.izbranZapis[0].namen) ? this.izbranZapis[0].namen : '';
      this.IzbranaNaloga = (this.izbranZapis[0].naloga) ? this.izbranZapis[0].naloga : '';
      this.stPristankov = (this.izbranZapis[0].st_pristankov) ? this.izbranZapis[0].st_pristankov : '';

      this.CasPristanka = (this.izbranZapis[0].cas_pristanka == null) ? '' : this.izbranZapis[0].cas_pristanka;
      this.CasLetenja = (this.izbranZapis[0].cas_letenja == null) ? '' : this.izbranZapis[0].cas_letenja;
      this.KlubLetala = (this.izbranZapis[0].klub_letala == null) ? '' : this.izbranZapis[0].klub_letala;
      this.KlubPilot = (this.izbranZapis[0].klub_pilot == null) ? '' : this.izbranZapis[0].klub_pilot;
      this.DatumLetenja = (this.izbranZapis[0].datum == null) ? '' : this.izbranZapis[0].datum;
      this.DatumVnosa = (this.izbranZapis[0].datum_vnosa == null) ? '' : this.izbranZapis[0].datum_vnosa;
      this.stanjeStevca = (this.izbranZapis[0].stanje_stevca == null) ? '' : this.izbranZapis[0].stanje_stevca;
      this.v_zraku = (this.izbranZapis[0].cas_leta_servis == null) ? '' : this.izbranZapis[0].cas_leta_servis;
    },
    PosodobiZapis() {
      if (this.pilotName !== '' && this.regLetala !== '' && this.IzbranNamen !== '' && this.IzbranaNaloga !== '' && this.krajVzleta !== '' && this.krajPristanka !== '' && this.poletanje !== '' && this.pristanek !== null) {
        this.dodajam = true;
        let app = this;
        let dodaj = new URLSearchParams();
        //preverjanje časa, da ni v prihodnosti
        let cas = new Date();
        cas.setHours(cas.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
        cas.setMinutes(cas.getMinutes() + 15); //dovolimo 15 minut v prihodnost
        cas = cas.toISOString().split('T')[1].split('.')[0];
        let casP = new Date();
        casP.setHours(casP.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
        casP = casP.toISOString().split('T')[1].split('.')[0];
        if (this.poletanje > casP || this.pristanek > cas) {
          this.dodajam = false;
          // alert("Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!");
          app.text = app.$t('obvestila.zapisCasPrihodnost');
          app.types = "Napaka";
          app.ShowNoti = true;
          return;
        }
        dodaj.append('uID', app.idUrejanja);
        dodaj.append('datum', app.datum);
        dodaj.append('pilot', app.pilotName);
        dodaj.append('instruktor', app.instructorName);
        dodaj.append('reg_letala', app.regLetala);
        dodaj.append('namen', app.IzbranNamen);
        dodaj.append('naloga', app.IzbranaNaloga);
        dodaj.append('kraj_vzleta', app.krajVzleta);
        dodaj.append('kraj_pristanka', app.krajPristanka);
        dodaj.append('poletanje', app.poletanje);
        // dodaj.append('cas_vziga', app.casVziga);
        dodaj.append('pristanek', app.pristanek);
        // dodaj.append('cas_ugasanja', app.casUgasanja);
        dodaj.append('opomba', app.opomba);
        dodaj.append('st_pristankov', app.stPristankov);
        dodaj.append('stanje_stevca', app.stanjeStevca);
        dodaj.append('cas_leta_servis', app.v_zraku);
        axios.post('./api/log/ultralight/uredi/', dodaj, {withCredentials: true}).then((response) => {
          this.dodajam = false;
          //reaktivna posodobitev podatkov pilota
          this.izbranZapis[0].pilot = this.pilotName;
          this.izbranZapis[0].instruktor = this.instructorName;
          this.izbranZapis[0].registracija = this.regLetala;
          this.izbranZapis[0].kraj_vzleta = this.krajVzleta;
          this.izbranZapis[0].kraj_pristanka = this.krajPristanka;
          this.izbranZapis[0].cas_vzleta = this.poletanje;
          this.izbranZapis[0].cas_pristanka = this.pristanek;
          this.izbranZapis[0].opomba = this.opomba;
          this.izbranZapis[0].namen = this.IzbranNamen;
          this.izbranZapis[0].naloga = this.IzbranaNaloga;
          this.izbranZapis[0].st_pristankov = this.stPristankov;
          this.izbranZapis[0].stanje_stevca = this.stanjeStevca;
          this.izbranZapis[0].cas_leta_servis = this.v_zraku;
          //ponastavitev vrednosti
          this.pilotName = '';
          this.instructorName = '';
          this.regLetala = '';
          this.krajVzleta = '';
          this.krajPristanka = '';
          this.poletanje = '';
          this.pristanek = '';
          this.opomba = '';
          this.IzbranNamen = '';
          this.IzbranaNaloga = '';
          this.stPristankov = '';
          this.v_zraku = '';
          this.urejanje = false;
          this.$emit('osvezi');
          // alert('Posodobitev uspešna');
          this.text = this.$t('obvestila.posodobitevUspesna');
          this.types = "Uspešno";
          this.ShowNoti = true;
        }).catch((napaka) => {
          this.dodajam = false;
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = this.$t('obvestila.napakaPosodabljanja');
          } else {
            this.text = this.$t('obvestila.napakaPosodabljanja');
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      } else {
        // alert('Napaka pri vnosu, preglej če imaš izpolnjena vsa polja!');
        this.text = this.$t('obvestila.napakaVnosa');
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    ZakljuciLet() {
      if (this.pristanek !== '') {
        this.dodajam = true;
        let app = this;
        let dodaj = new URLSearchParams();
        //preverjanje časa, da ni v prihodnosti
        let cas = new Date();
        cas.setHours(cas.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
        cas.setMinutes(cas.getMinutes() + 15); //dovolimo 15 minut v prihodnost
        cas = cas.toISOString().split('T')[1].split('.')[0];
        var datumDanes = new Date().toISOString().split('T')[0];
        datumDanes = datumDanes.split('-').reverse();
        datumDanes = datumDanes[0] + '.' + datumDanes[1] + '.' + datumDanes[2];
        if (this.izbranZapis[0].datum === datumDanes) {
          if (this.pristanek > cas) { //"časovna omejtiev" velja samo za tekoči datum
            // alert("Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!");
            this.dodajam = false;
            app.text = this.$t('obvestila.zapisCasPrihodnost');
            app.types = "Napaka";
            app.ShowNoti = true;
            return;
          }
        }
        if (this.pristanek < this.poletanje) {
          this.dodajam = false;
          app.text = app.$t('obvestila.napakaPristanka');
          app.types = "Napaka";
          app.ShowNoti = true;
          return;
        }
        dodaj.append('uID', app.idUrejanja);
        dodaj.append('cas_pristanka', app.CasPristanka);
        dodaj.append('pilot', app.pilotName);
        dodaj.append('klub_letala', app.KlubLetala);
        dodaj.append('instruktor', app.instructorName);
        dodaj.append('reg_letala', app.regLetala);
        dodaj.append('namen', app.IzbranNamen);
        dodaj.append('naloga', app.IzbranaNaloga);
        dodaj.append('kraj_vzleta', app.krajVzleta);
        dodaj.append('kraj_pristanka', app.krajPristanka);
        dodaj.append('poletanje', app.poletanje);
        dodaj.append('cas_odklopa', app.casOdklopa);
        dodaj.append('cas_vleke', app.casVleke);
        dodaj.append('pristanek', app.pristanek);
        dodaj.append('st_pristankov', app.stPristankov);
        dodaj.append('cas_letenja', app.CasLetenja);
        dodaj.append('reg_vleke', app.regVleka);
        dodaj.append('opomba', app.opomba);
        dodaj.append('klub_pilot', app.KlubPilot);
        dodaj.append('datum_letenja', app.DatumLetenja);
        dodaj.append('datum_vnosa', app.DatumVnosa);
        dodaj.append('stanje_stevca', app.stanjeStevca);
        dodaj.append('cas_leta_servis', app.v_zraku);
        axios
            .post("./api/log/ultralight/uredi/", dodaj, {withCredentials: true})
            .then((response) => {
              this.dodajam = false;
              this.pilotName = '';
              this.instructorName = '';
              this.regLetala = '';
              this.IzbranNamen = '';
              this.IzbranaNaloga = '';
              this.krajVzleta = '';
              this.krajPristanka = '';
              this.poletanje = '';
              this.casOdklopa = '';
              this.casVleke = '';
              this.pristanek = '';
              this.regVleka = '';
              this.opomba = '';
              this.stPristankov = '';
              this.CasPristanka = '';
              this.KlubLetala = '';
              this.CasLetenja = '';
              this.KlubPilot = '';
              this.DatumLetenja = '';
              this.DatumVnosa = '';
              this.stanjeStevca = '';
              this.v_zraku = '';
              // this.urejanje = false;
              // alert('Posodobitev uspešna');
              this.$emit('osvezi');
              this.text = this.$t('obvestila.letZakljucen');
              this.types = "Uspešno";
              this.ShowNoti = true;
              this.DetailsOffZ();
            })
            .catch((napaka) => {
              this.dodajam = false;
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.napaka !== undefined) {
                this.text = this.$t('obvestila.letNiZakljucen');
              } else {
                this.text = this.$t('obvestila.letNiZakljucen');
              }
              this.types = 'Napaka';
              this.ShowNoti = true;
            })
      } else {
        this.text = this.$t('obvestila.napakaPrazenPristanek');
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    PotrdiIzbris(id) {
      this.podatkiIzbris = {
        id: id
      };
      this.text = this.$t('obvestila.vprasanjeIzbris');
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      let text = 'Ali res želite pobrisati zapis?';
      // BRISANJE
      let app = this;
      let izbris = new URLSearchParams();
      izbris.append("id_brisanja", this.podatkiIzbris.id);
      axios
          .post("./api/log/ultralight/brisi/", izbris)
          .then(function (response) {
            text = "Zapis uspešno pobrisan";
            app.$emit('osvezi');
            app.DetailsOff();
            app.podatkiIzbris = {};
            app.text = text;
            app.types = "Uspešno";
            app.ShowNoti = true;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaIzbrisa');
            } else {
              this.text = this.$t('obvestila.napakaIzbrisa');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    ToogleSort() {
      this.sortAscending = !this.sortAscending;
      this.PodatkiObracun.reverse();
      this.PodatkiNezakljuceni.reverse();
    },
    selectPilot(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotName = pilot.sifra;
        this.dPilot = false;
      }
    },
    selectPilotF(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        this.filterPilot = pilot.sifra;
        this.dPilot = false;
      }
    },
    selectInstructor(id) {
      let instruktor = this.Piloti.piloti.find(ins => ins.id === id);
      if (instruktor) {
        this.instructorName = instruktor.ime + ' ' + instruktor.priimek;
        this.dInstruktor = false;
      }
    },
    selectInstructorF(id) {
      let instruktor = this.Piloti.piloti.find(ins => ins.id === id);
      if (instruktor) {
        this.filterInstruktor = instruktor.ime + ' ' + instruktor.priimek;
        this.dInstruktor = false;
      }
    },
    selectLetalo(id) {
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    selectLetaloF(id) {
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        this.filterLetalo = letalo.registracija;
        this.dLetalo = false;
      }
    },
    selectNamen(id) {
      let namen = this.namen.find(n => n.id === id);
      if (namen) {
        this.dNamen = false;
        this.IzbranNamen = namen.namen;
      }
    },
    selectNaloga(id) {
      let naloga = this.naloga.find(na => na.id === id);
      if (naloga) {
        this.dNaloga = false;
        this.IzbranaNaloga = naloga.naloga;
      }
    },
    selectPristanek(id) {
      let pristanek = this.Letalisca.letalisca.find(pr => pr.id === id);
      if (pristanek) {
        this.dPristanek = false;
        this.krajPristanka = pristanek.icao;
      }
    },
    selectVzlet(id) {
      let vzlet = this.Letalisca.letalisca.find(vl => vl.id === id);
      if (vzlet) {
        this.dVzlet = false;
        this.krajVzleta = vzlet.icao;
      }
    },
    OpenPilot() {
      this.dPilot = !this.dPilot;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OpenInstructor() {
      this.dInstruktor = !this.dInstruktor;
    },
    OpenNamen() {
      this.dNamen = !this.dNamen;
    },
    OpenNaloga() {
      this.dNaloga = !this.dNaloga;
    },
    OpenVzlet() {
      this.dVzlet = !this.dVzlet;
    },
    OpenPristanek() {
      this.dPristanek = !this.dPristanek;
    },
    LahkoZakljuci() {
      var danes = new Date().toISOString().split('T')[0].split('-').reverse();
      danes = danes[0] + '.' + danes[1] + '.' + danes[2];
      if (this.user.lvl > 1) {
        if (this.user.lvl > 3) {
          if (this.izbranZapis[0].vnesel === Number(this.user.id) || this.izbranZapis[0].pilot === this.izbranZapis[0].sifra_poizvedovalec) {
            return this.izbranZapis[0].datum === danes;
          } else {
            return false;
          }
        } else {
          return true; //če je kronometrist dovolimo vse
        }
        return this.izbranZapis[0].datum === danes;
      } else if (this.user.lvl < 1) {
        return true;
      }
    },
    sestejCase() {
      let skupneMinute = 0;
      let skupneUre = 0;
      for (let i = 0; i < this.FiltriraniPodatki.length; i++) {
        // Pretvori oba časa v minute
        var [ure, minute] = this.FiltriraniPodatki[i].cas_letenja.split(':').map(Number);
        skupneMinute += minute;
        skupneUre += ure;
      }
      while (skupneMinute >= 60) {
        skupneMinute -= 60;
        skupneUre++;
      }
      // Formatiraj nazaj v HH:MM
      const ureStr = String(skupneUre).padStart(2, '0');
      const minuteStr = String(skupneMinute).padStart(2, '0');

      return `${ureStr}:${minuteStr}`;
    },
    SestejPristanke() {
      let pristanki = 0;
      for (let i = 0; i < this.FiltriraniPodatki.length; i++) {
        // Pretvori oba časa v minute
        pristanki += this.FiltriraniPodatki[i].st_pristankov;
      }
      return pristanki;
    },
    NatisniIzpise() {
      this.printing = true;
      var podatki = new URLSearchParams();
      podatki.append('zapisiU', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.printing = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.printing = false;
      });
    },
    IzvozCSV() {
      this.exporting = true;
      var podatki = new URLSearchParams();
      podatki.append('zapisiU', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/csv/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.exporting = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.exporting = false;
      });
    },
    SendToMail() {
      this.sending = true;
      var podatki = new URLSearchParams();
      podatki.append('zapisiU', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {withCredentials: true}).then((response) => {
        var podatkiMail = new URLSearchParams();
        podatkiMail.append('datoteka', response.data.datoteka);
        podatkiMail.append('zadeva', 'Izpisek ultralight letov');
        podatkiMail.append('osebno', true);
        axios.post('./api/log/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // alert(response.data.sporocilo);
          this.text = (response.data.sporocilo);
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.sending = false;
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pošiljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pošiljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.sending = false;
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.sending = false;
      });
    },
    async NastavitevPregleda() {
      await axios.get('./api/nastavitve/pregled/').then((response) => {
        this.dniPregleda = response.data.dni;
      }).catch((error) => {
        //TODO
      });
    },
    NastaviDatum() {
      let datum = new Date();
      datum.setDate(datum.getDate() - this.dniPregleda);

      return datum.toISOString().split('T')[0];
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="container p-2" v-if="prevodi">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="izbrisiZapis" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
    </Transition>
    <div class="">
      <h4 class="text-white">{{$t('mainUL.title')}} <button class="btn btn-sm btn-outline-secondary" @click.prevent="ToogleSort()"><i v-if="sortAscending" class="fas fa-chevron-down"></i> <i v-if="!sortAscending" class="fas fa-chevron-up"></i></button></h4>
      <!-- NEZAKLJUČENI -->
      <section class="flight-section-pregled mt-2" v-if="PodatkiNezakljuceni.length > 0">

        <div class="section-header">
          <div class="section-icon motor">
            <i class="fas fa-plane"></i>
          </div>
          <div>
            <h2>{{ $t('table.titleU') }}</h2>
            <span>{{ PodatkiNezakljuceni.length }} zapisov</span>
          </div>
          <div class="d-flex col-md-8 justify-content-center">
            <h2 class="text-danger"> {{ $t('main.nezakljuceni') }}</h2>
          </div>
        </div>

        <div class="flight-list">

          <div
              class="flight-item-pregled"
              v-for="(id, index) in PodatkiNezakljuceni"
              @click.prevent="OpenViewZ(id.id)"
          >

            <div class="flight-date">
              <i class="fas fa-plane"></i>
              <span>{{ id.registracija }}</span>
            </div>

            <div class="flight-task">
              <span class="label-flight">{{$t('table.datum')}}</span>
              <strong>{{ id.datum.substring(0,5) }}</strong>
            </div>
            <div class="flight-user">
              <span class="label-flight">{{$t('table.vzlet')}} <i class="fas" :class="{'fa-sort-up' : sortAscending, 'fa-sort-down' : !sortAscending}"></i></span>
              <strong>{{ id.cas_vzleta }}</strong>
            </div>

            <div class="flight-task">
              <span class="label-flight">{{$t('table.pilot')}}</span>
              <strong>{{ id.pilot }}</strong>
            </div>

            <div class="flight-task">
              <span class="label-flight">{{$t('table.naloga')}}</span>
              <strong>{{ id.naloga }}</strong>
            </div>

            <div class="flight-action">
              <i class="fas fa-chevron-right"></i>
            </div>

          </div>

          <div v-if="!PodatkiNezakljuceni.length" class="empty-state">
            <i class="far fa-folder-open"></i>
            <span>Ni podatkov</span>
          </div>

        </div>

      </section>
      <!-- ZAKLJUČENI -->
      <div class="col-12">
        <div class="container">
          <div class="label-date p-2 col-6">{{$t('labels.datumOd')}}</div>
          <input class="input border-0 rounded-4 p-2 fs-5"
                 type="date" id="datum"
                 :max="(this.user.lvl <= 1 || this.user.lvl > 3) ? '' : new Date().toISOString().split('T')[0]"
                 :min="(this.user.lvl === 2) ? NastaviDatum() : ''"
                 v-model="datumO"
                 required
                 @change="GetPodatkiObracuna"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="container">
          <div class="label-date p-2 col-6">{{$t('labels.datumDo')}}</div>
          <input class="input border-0 rounded-4 p-2 fs-5"
                 type="date" id="datum"
                 :disabled="this.user.lvl > 2 && this.user.lvl < 4"
                 :min="(this.user.lvl === 2) ? NastaviDatum() : ''"
                 v-model="datumD"
                 required
                 @change="GetPodatkiObracuna" />
        </div>
      </div>
      <!-- FILTRI -->
      <div v-if="this.user.lvl <=4">
        <div class="hr-with-text">Filtriranje podatkov</div>
        <!-- PILOT FILTER -->
        <div class="col-12">
          <div class="container">
            <label class="label-dropdown" for="filterPilot">{{$t('edit.pilot')}} <button v-if="filterPilot !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="filterPilot = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
            <div class="drop-down-icon text-black" @click.prevent="OpenPilot()" >
              <i v-show="!dPilot" class="fas fa-chevron-right"></i>
              <i v-show="dPilot" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 p-2 fs-5" id="filterPilot" @click.prevent="OpenPilot">{{filterPilot}}</button>
            <transition name="fade">
              <drop-down @pilot="selectPilotF" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot" />
            </transition>
          </div>
        </div>
        <!-- INŠTRUKTOR FILTER -->
        <div class="col-12">
          <div class="container">
            <label class="label-dropdown" for="filterInstruktor">{{$t('edit.instruktor')}} <button v-if="filterInstruktor !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="filterInstruktor = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
            <div class="drop-down-icon text-black" @click.prevent="OpenInstructor()">
              <i v-show="!dInstruktor" class="fas fa-chevron-right"></i>
              <i v-show="dInstruktor" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 p-2 fs-5" id="filterInstruktor" @click.prevent="OpenInstructor">{{filterInstruktor}}</button>
            <transition name="fade">
              <drop-down @instruktor="selectInstructorF" :data="Instruktor" type="instruktor" class="drop-down-btn" v-if="dInstruktor" />
            </transition>
          </div>
        </div>
        <!-- LETALO FILTER -->
        <div class="col-12">
          <div class="container">
            <label class="label-dropdown" for="regLetala">{{$t('edit.reg')}}<button v-if="filterLetalo !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="filterLetalo = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
            <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()" >
              <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
              <i v-show="dLetalo" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenLetalo">{{filterLetalo}}</button>
            <transition name="fade">
              <drop-down @letalo="selectLetaloF" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo" />
            </transition>
          </div>
        </div>
      </div>
      <!-- /FILTRI -->
      <!-- IZPIS -->
      <div v-if="this.user.lvl <=4">
        <h4 class="text-white">{{$t('data.title')}}</h4>
        <div class='row'>
          <div class='col-5'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.exporting" @click.prevent="IzvozCSV" data-umami-event="Ultralight-zapisi-csv">{{$t('buttons.csv')}}<i class="fas fa-file-csv" :class="{'fa-spin' : this.exporting}"></i></button>
          </div>
          <div class='col-4'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.printing" @click.prevent="NatisniIzpise" data-umami-event="Ultralight-zapisi-tisk">{{$t('buttons.natisni')}} <i class="fas fa-print" :class="{'fa-spin' : this.printing}"></i></button>
          </div>
          <div class='col-3 text-center'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.sending" @click.prevent="SendToMail" data-umami-event="Ultralight-zapisi-email">{{$t('buttons.poslji')}} <i class="far fa-envelope" :class="{'fa-spin' : this.sending}"></i></button>
          </div>
        </div>
      </div>
      <!-- /IZPIS -->
    </div>
    <!-- ZAKLJUČENI LETI -->
    <section class="flight-section-pregled mt-2">

      <div class="section-header">
        <div class="section-icon motor">
          <i class="fas fa-plane"></i>
        </div>
        <div class="d-flex col-10 justify-content-between">
          <div>
            <h2>{{ $t('table.titleU') }}</h2>
            <span>{{ FiltriraniPodatki.length }} zapisov</span>
          </div>
          <div >
            <h2 class="text-success"> {{ $t('main.zakljuceni') }}</h2>
            <span>{{$t('data.stPristankov')}} {{this.SestejPristanke()}}</span>
          </div>
          <div>
            <h2>{{ $t('data.casVZraku') }}</h2>
            <span> {{ this.sestejCase() }} </span>
          </div>
        </div>
      </div>

      <div class="flight-list">

        <div
            class="flight-item-pregled"
            v-for="(id, index) in FiltriraniPodatki"
            @click.prevent="OpenView(id.id)"
        >

          <div class="flight-task">
            <span class="label-flight">{{$t('table.datum')}}</span>
            <strong>{{ id.datum.substring(0,5) }}</strong>
          </div>
          <div class="flight-date">
            <i class="fas fa-plane"></i>
            <span>{{ id.registracija }}</span>
          </div>
          <div class="flight-user">
            <span class="label-flight">{{$t('table.vzlet')}} <i class="fas" :class="{'fa-sort-up' : sortAscending, 'fa-sort-down' : !sortAscending}"></i></span>
            <strong>{{ id.cas_vzleta }}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.pristanek')}}</span>
            <strong>{{ id.cas_pristanka }}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.pilot')}}</span>
            <strong>{{ id.pilot }}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.naloga')}}</span>
            <strong>{{ id.naloga }}</strong>
          </div>

          <div class="flight-action">
            <i class="fas fa-chevron-right"></i>
          </div>

        </div>

        <div v-if="!FiltriraniPodatki.length" class="empty-state">
          <i class="far fa-folder-open"></i>
          <span>Ni podatkov</span>
        </div>

      </div>

    </section>
    <!-- /ZAKLJUČENI -->
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
    <div class='col-12 p-2'></div>
    <!-- OBRAČUN PODROBNO -->
    <div class="modal modal-kartica" ref="modalObracunMotZapisa" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="fas fa-plane"></i> Izbran zapis (ultralight)</h5>
          </div>
          <div class="modal-body col-12" style="overflow-y: scroll;">
            <ul class='list-group list-group-flush' v-if="!this.urejanje">
              <li class='list-group-item list-dark'>{{$t('modal.registracija')}} {{izbranZapis[0].registracija}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.vlecno')}} <i class="fas" :class="{'fa-times': !izbranZapis[0].vlecno, 'fa-check': izbranZapis[0].vlecno }"></i></li>
              <li class='list-group-item list-dark'>{{$t('modal.pilot')}} {{izbranZapis[0].pilot}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} {{izbranZapis[0].instruktor}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.namen')}} {{izbranZapis[0].namen}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naloga')}} {{izbranZapis[0].naloga}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.vzlet')}} {{izbranZapis[0].kraj_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.pristanek')}} {{izbranZapis[0].kraj_pristanka}}</li>
              <!-- <li class='list-group-item list-dark'>čas vziga: {{izbranZapis[0].cas_vziga}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.casVzleta')}} {{izbranZapis[0].cas_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.casPristanka')}} {{izbranZapis[0].cas_pristanka}}</li>
              <!-- <li class='list-group-item list-dark'>čas ugasanja: {{izbranZapis[0].cas_ugasanja}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.casLetenja')}} {{izbranZapis[0].cas_letenja}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.v_zraku')}} {{izbranZapis[0].cas_leta_servis}}</li>
              <!-- <li class='list-group-item list-dark'>čas stanja: {{izbranZapis[0].cas_stanja}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.stPristankov')}} {{izbranZapis[0].st_pristankov}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.stanjeStevca')}} {{izbranZapis[0].stanje_stevca}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.ifr')}} {{izbranZapis[0].ifr}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.nocno')}} {{izbranZapis[0].nocno}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.vizuelno')}} {{izbranZapis[0].vizuelno}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].opomba}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.datumL')}} {{izbranZapis[0].datum}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.datumV')}} {{izbranZapis[0].datum_vnosa}}</li>
            </ul>
            <!-- UREJANJE PODATKOV -->
            <ul class='list-group list-group-flush' v-else>
              <li class='list-group-item list-dark'>{{$t('modal.registracija')}} <span class='text-lorange'>{{izbranZapis[0].registracija}}</span>
                <div class="container">
                  <label class="label-dropdown" for="regLetala">{{$t('edit.reg')}} <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="regLetala = ''">Pobriši izbiro</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
                    <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
                    <i v-show="dLetalo" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenLetalo">{{regLetala}}</button>
                  <transition name="fade">
                    <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.pilot')}} <span class='text-lorange'>{{izbranZapis[0].pilot}}</span>
                <div class="container">
                  <label class="label-dropdown" for="pilotName">{{$t('edit.pilot')}} <button v-if="pilotName !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="pilotName = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenPilot()">
                    <i v-show="!dPilot" class="fas fa-chevron-right"></i>
                    <i v-show="dPilot" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="pilotName" @click.prevent="OpenPilot">{{pilotName}}</button>
                  <transition name="fade">
                    <drop-down @pilot="selectPilot" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} <span class='text-lorange'>{{izbranZapis[0].instruktor}}</span>
                <div class="container">
                  <label class="label-dropdown" for="instructorName">{{$t('edit.instruktor')}} <button v-if="instructorName !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="instructorName = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenInstructor()">
                    <i v-show="!dInstruktor" class="fas fa-chevron-right"></i>
                    <i v-show="dInstruktor" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="instructorName" @click.prevent="OpenInstructor">{{instructorName}}</button>
                  <transition name="fade">
                    <drop-down @instruktor="selectInstructor" :data="Instruktor" type="instruktor" class="drop-down-btn" v-if="dInstruktor" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.namen')}} <span class='text-lorange'>{{izbranZapis[0].namen}}</span>
                <div class="container">
                  <label class="label-dropdown" for="namen">{{$t('edit.namen')}} <button v-if="IzbranNamen !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="IzbranNamen = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenNamen()">
                    <i v-show="!dNamen" class="fas fa-chevron-right"></i>
                    <i v-show="dNamen" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenNamen">{{IzbranNamen}}</button>
                  <transition name="fade">
                    <drop-down @namen="selectNamen" :data="namen" type="namen" class="drop-down-btn" v-if="dNamen" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.naloga')}}: <span class='text-lorange'>{{izbranZapis[0].naloga}}</span>
                <div class="container">
                  <label class="label-dropdown" for="namen">{{$t('edit.naloga')}} <button v-if="IzbranaNaloga !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="IzbranaNaloga = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenNaloga()">
                    <i v-show="!dNaloga" class="fas fa-chevron-right"></i>
                    <i v-show="dNaloga" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="IzbranaNaloga" @click.prevent="OpenNaloga">{{IzbranaNaloga}}</button>
                  <transition name="fade">
                    <drop-down @naloga="selectNaloga" :data="naloga" type="naloga" class="drop-down-btn" v-if="dNaloga" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.vzlet')}} <span class='text-lorange'>{{izbranZapis[0].kraj_vzleta}}</span>
                <div class="container">
                  <label class="label-dropdown" for="namen">{{$t('edit.krajV')}} <button v-if="krajVzleta !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="krajVzleta = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenVzlet()">
                    <i v-show="!dVzlet" class="fas fa-chevron-right"></i>
                    <i v-show="dVzlet" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5"  id="krajVzleta" @click.prevent="OpenVzlet">{{krajVzleta}}</button>
                  <transition name="fade">
                    <drop-down @vzlet="selectVzlet" :data="Letalisca" type="vzlet" class="drop-down-btn" v-if="dVzlet" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.pristanek')}}<span class='text-lorange'> {{izbranZapis[0].kraj_pristanka}}</span>
                <div class="container">
                  <label class="label-dropdown" for="krajPristanka">{{$t('edit.krajP')}} <button v-if="krajPristanka !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="krajPristanka = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenPristanek()">
                    <i v-show="!dPristanek" class="fas fa-chevron-right"></i>
                    <i v-show="dPristanek" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5"  id="krajPristanka" @click.prevent="OpenPristanek">{{krajPristanka}}</button>
                  <transition name="fade">
                    <drop-down @pristanek="selectPristanek" :data="Letalisca" type="pristanek" class="drop-down-btn" v-if="dPristanek" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.casVzleta')}} <span class='text-lorange'>{{izbranZapis[0].cas_vzleta}} </span>
                <div class="container">
                  <label :class="{ hidden: poletanje.length > 0 }" class="label-time p-2" for="poletanje">Block on:</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Poletanje" id="poletanje" v-model="poletanje" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.casPristanka')}} <span class='text-lorange'>{{izbranZapis[0].cas_pristanka}}</span>
                <div class="container">
                  <label :class="{ hidden: pristanek.length > 0 }" class="label-time p-2" for="pristanek">Block off:</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Pristanek" id="pristanek" v-model="pristanek" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.stPristankov')}} <span class='text-lorange'>{{izbranZapis[0].st_pristankov}}</span>
                <div class="container">
                  <label :class="{ hidden: stPristankov.length > 0 }" class="label-time p-2" for="casUgasanja">Št. pristankov :</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="stPristankov" v-model="stPristankov" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modalNL.v_zraku')}} <span class='text-lorange'>{{izbranZapis[0].cas_leta_servis}}</span>
                <div class="container">
                  <label :class="{ hidden: v_zraku.length > 0 }" class="label-time p-2" for="v_zraku">{{$t('modalNL.v_zraku')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" id="v_zraku" v-model="v_zraku" />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.stanjeStevca')}} <span class='text-lorange'>{{izbranZapis[0].stanje_stevca}}</span>
                <div class="container">
                  <label :class="{ hidden: stanjeStevca.length > 0 }" class="label-time p-2" for="casUgasanja">Stanje števca :</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="stanjeStevca" v-model="stanjeStevca" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modal.opomba')}} <span class='text-lorange'>{{izbranZapis[0].opomba}}</span>
                <div class="container">
                  <label :class="{ hidden: opomba.length > 0 }" class="label" for="opomba">{{$t('edit.opomba')}}</label>
                  <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opomba" v-model="opomba" rows="6" autocomplete="off">
                                    </textarea>
                </div>
              </li>
            </ul>
          </div>
          <div class="modal-footer col-12">
            <span class='text-manjsi text-danger' v-if="this.izbranZapis[0].naloga === 'Vleka'">{{$t('label.niMozno')}}</span>
            <button class="btn"
                    :class="{'btn-light' : this.izbranZapis[0].naloga === 'Vleka',
                    'btn-outline-warning': this.izbranZapis[0].naloga !== 'Vleka',
                    'disabled': LahkoUreja() === false}"
                    v-if="!this.urejanje" :disabled="this.izbranZapis[0].naloga === 'Vleka'"
                    @click.prevent="UrediZapis(izbranZapis[0].id)"
            >
              <i class="fas fa-user-edit"></i><s v-if="LahkoUreja() === false" >{{$t('buttons.urediPodatke')}} </s> <span v-if="LahkoUreja()">{{$t('buttons.urediPodatke')}} </span>
            </button>
            <button class="btn btn-outline-success" v-else @click.prevent="PosodobiZapis()"
                    :disabled="dodajam"
            >
              <i class="fas fa-sync-alt" :class="{'fa-spin': dodajam}"></i> {{$t('buttons.posodobiPodatke')}}
            </button>&nbsp;
            <button v-if="!this.urejanje" class="btn btn-outline-danger"
                    :class="{'disabled': LahkoBrise() === false }"
                    @click.prevent="PotrdiIzbris(izbranZapis[0].id)"
            >{{$t('buttons.izbrisiZapis')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL NEZAKLJUČENI LETI -->
    <div class="modal modal-kartica" ref="modalObracunOdprti" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" v-if="izbranZapis.length > 0">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOffZ">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="fas fa-plane"></i> {{$t('modalNL.title')}}</h5>
          </div>
          <div class="modal-body col-12" style="overflow-y: scroll;">
            <ul class='list-group list-group-flush'>
              <li class='list-group-item list-dark'>{{$t('modalNL.reg')}} {{izbranZapis[0].registracija}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.pilot')}}{{izbranZapis[0].pilot}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.instruktor')}} {{izbranZapis[0].instruktor}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.namen')}} {{izbranZapis[0].namen}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.naloga')}} {{izbranZapis[0].naloga}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.casV')}}{{izbranZapis[0].cas_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.krajV')}} {{izbranZapis[0].kraj_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.krajP')}} {{izbranZapis[0].kraj_pristanka}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.casL')}} {{izbranZapis[0].cas_letenja}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.stanjeStevca')}} {{izbranZapis[0].stanje_stevca}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.v_zraku')}} {{izbranZapis[0].cas_leta_servis}}</li>
              <!-- <li class='list-group-item list-dark'>Št. pristankov: {{izbranZapis[0].st_pristankov}}</li>stPristankov -->
              <li class='list-group-item list-dark'>
                <div class="container">
                  <label :class="{ hidden: stPristankov.length > 0 }" class="label-time p-2" for="stPristankov">{{$t('modal.stPristankov')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="number" placeholder="" ref="stPristankov" v-model="stPristankov" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>
                <div class="container">
                  <label :class="{ hidden: pristanek.length > 0 }" class="label-time p-2" for="pristanek">{{$t('modalNL.pristanekM')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Pristanek" ref="pristanekZ" v-model="pristanek" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>
                <!-- V ZRAKU -->
                <div class="container">
                  <label :class="{ hidden: v_zraku.length > 0 }" class="label-time p-2" for="v_zraku">{{$t('modalNL.v_zraku')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" id="v_zraku" v-model="v_zraku" />
                </div>
              </li>
              <li class='list-group-item list-dark'>
                <!-- STANJE ŠTEVCA -->
                <div class="container">
                  <label :class="{ hidden: stanjeStevca.length > 0 }" class="label-time p-2" for="casUgasanja">{{$t('modalNL.stanjeStevca')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="stanjeStevca" v-model="stanjeStevca" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('modalNL.klubL')}} {{izbranZapis[0].klub_letala}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.klubP')}} {{izbranZapis[0].klub_pilot}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.opomba')}} {{izbranZapis[0].opomba}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.datumL')}} {{izbranZapis[0].datum}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.datumV')}} {{izbranZapis[0].datum_vnosa}}</li>
            </ul>
          </div>
          <div class="modal-footer col-12">
            <button class="btn btn-outline-success" :class="{'disabled': LahkoZakljuci() === false }" @click.prevent="ZakljuciLet()" :disabled="dodajam">
              <i class="fas fa-sync-alt" :class="{'fa-spin': dodajam}"></i> {{$t('buttons.zakljuciLet')}}
            </button>
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>